import { Component, OnInit, Output, EventEmitter } from "@angular/core";
import { environment } from "@environment";
import { PortageService } from "@services/portage.service";
import { AuthenticationService } from "@services/security";
import { USER_ROLES, AppConsts } from "@shared/app-consts";
import { ApiPortageParameters } from "@shared/models/api-portage-parameters";
import { EcfQuestionnaireService } from "@services/ecf-questionnaire.service";
import { EcfBanner, ecfBanner } from "@modules/ecf/questionnaire/ecf-questionnaire-banner";
import { formatDate } from "@modules/ecf/questionnaire/ecf-questionnaire-rules";

@Component({
  selector: "app-home",
  templateUrl: "./home.component.html",
  styleUrls: ["./home.component.css"],
  standalone: false
})
export class HomeComponent implements OnInit {
  currentUserEmail: string;
  showBankModule: boolean = false;
  @Output() close: EventEmitter<any> = new EventEmitter();
  readonly USER_ROLES = USER_ROLES;


  production:boolean = environment.production;
  parameters: ApiPortageParameters;
  ecfBanner: EcfBanner = null;
  readonly formatEcfDate = formatDate;

  constructor(private authService: AuthenticationService,private gestionPortageSalarialService:PortageService,
    private ecfQuestionnaireService: EcfQuestionnaireService) {
    const userData = this.authService.getLocalUserData();
    // Fix temporaire : ajouter les rôles s'ils sont manquants
    if (userData && !userData.UserRoles) {
      userData.UserRoles = ['Portage Salarial', 'Comptabilité', 'CrmClient'];
      sessionStorage.setItem('auth-token', JSON.stringify(userData));
    }
  }

  ngOnInit() {
    this.authService.authenticationState.subscribe(() => {
      var jwtToken = JSON.parse(sessionStorage.getItem(AppConsts.TOKEN_KEY));
      this.currentUserEmail = jwtToken == null ? '' : jwtToken.UserEMail;
      this.showBankModule = (this.currentUserEmail == 'azedkalda@gmail.com') || (this.currentUserEmail == 'a.kalda@fiparco.fr');
    });
    //this.getApiPortageParameters();
    this.loadEcfBanner();
  }

  /** Bandeau du questionnaire ECF ; rien d'affiché si la liste ne peut pas être lue (FR-001). */
  loadEcfBanner() {
    if (!this.authService.IsAuthenticated())
      return;
    this.ecfQuestionnaireService.getMine().subscribe({
      next: questionnaires => this.ecfBanner = ecfBanner(questionnaires),
      error: () => this.ecfBanner = null
    });
  }
  // getApiPortageParameters()
  // {

  //   this.gestionPortageSalarialService.getApiPortageParameters().subscribe((res:ApiPortageParameters) => {
  //     this.parameters=res;
  //        });
  // }
  closeMenu() {
    this.close.emit();
  }

  isProduction() {
    return AppConsts.IS_ENV_PRODUCTION;
  }

  openBEBOP(){
    window.open(
      "https://app.mybebop.fr/app/register?resetAccount=true",
      "_blank"
    );
  }
}
